var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container",style:(_vm.style)},[_c('div',{attrs:{"id":"regionMap"}},[(_vm.loading)?_c('DoubleBounce'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }